import { createAsyncThunk } from '@reduxjs/toolkit';
import { isAxiosError } from 'axios';
import instance, { ApiError, AsyncThunkConfig } from '../../api/axiosConfig';
import { ExaminationID } from '../../api/interfaces';
import {
  examinationReportURL,
  examinationResultURL,
  examinationURL,
  getExaminationStatusURL,
} from '../../utils/paths';
import {
  EmailData,
  EmailSendingStates,
  ExaminationResult,
  ExaminationStatus,
} from '../../api/maintestApi';
import { requestWithRetry } from '../../utils/retryRequest';

export const getExaminationId = createAsyncThunk<
  ExaminationID,
  string | undefined,
  AsyncThunkConfig
>('examination/post', async (token, thunkApi) => {
  try {
    const response = await requestWithRetry<ExaminationID>(
      examinationURL,
      true,
      { postBody: { token } }
    );
    return response.data;
  } catch (error) {
    if (isAxiosError(error) && error.response != null) {
      const extractedError = error.response.data as ApiError;

      return thunkApi.rejectWithValue(extractedError);
    }
    throw error;
  }
});

export const getExaminationStatus = createAsyncThunk<
  ExaminationStatus,
  string,
  AsyncThunkConfig
>('examination/status/get', async (id, thunkApi) => {
  try {
    const response = await requestWithRetry<ExaminationStatus>(
      getExaminationStatusURL(id)
    );
    return response.data;
  } catch (error) {
    if (isAxiosError(error) && error.response != null) {
      const extractedError = error.response.data as ApiError;

      return thunkApi.rejectWithValue(extractedError);
    }
    throw error;
  }
});

export const postEmailSending = createAsyncThunk<
  EmailSendingStates,
  EmailData,
  AsyncThunkConfig
>('examination/email/post', async (data, thunkApi) => {
  try {
    const response = await instance.post<EmailSendingStates>(
      examinationReportURL(data.id),
      { email: data.email }
    );
    return response.data;
  } catch (error) {
    if (isAxiosError(error) && error.response != null) {
      const extractedError = error.response.data as ApiError;

      return thunkApi.rejectWithValue(extractedError);
    }
    throw error;
  }
});

export const getExaminationResult = createAsyncThunk<
  ExaminationResult,
  string,
  AsyncThunkConfig
>('examination/result', async (id, thunkApi) => {
  try {
    const response = await requestWithRetry<ExaminationResult>(
      examinationResultURL(id)
    );

    return response.data;
  } catch (error) {
    if (isAxiosError(error) && error.response != null) {
      const extractedError = error.response.data as ApiError;

      return thunkApi.rejectWithValue(extractedError);
    }
    throw error;
  }
});
